import React, { Component } from "react";
import s from "./DogTestimonials.css";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { imageCdnUrl } from "../../../config";
import { Col, Row, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import messages from "../../../locale/messages";
import getWhyHostReview from "./getWhyHostReview.graphql";
import { graphql, compose } from "react-apollo";
import getWhyHostPageSettings from "./getWhyHostPageSettings.graphql";
import Swiper from "react-id-swiper";
import cx from "classnames";

import nextIcon from "/public/SiteIcons/right.svg";
import prevIcon from "/public/SiteIcons/left.svg";

const nextArrowStyle = {
  position: "absolute",
  right: "-20px",
  background: "transparent",
  color: "#00B0CD",
  zIndex: "5",
  width: "auto",
  height: "auto",
  top: "47%",
  fontSize: "40px",
  cursor: "pointer",
  borderRadius: "50%",
  textAlign: "center",
};

const prevArrowStyle = {
  position: "absolute",
  left: "-24px",
  background: "transparent",
  color: "#00B0CD",
  zIndex: "5",
  width: "auto",
  height: "auto",
  top: "47%",
  fontSize: "40px",
  cursor: "pointer",
  borderRadius: "50%",
  textAlign: "center",
};

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} style={nextArrowStyle} onClick={onClick}>
      <img src={nextIcon} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} style={prevArrowStyle} onClick={onClick}>
      <img src={prevIcon} />
    </div>
  );
}

class DogTestimonials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showArrow: false,
      load: false,
      showModal: false,
      modalText: "",
      modalName: "",
      modalImg: "",
      truncateLength: 200, // default desktop
    };
    this.swiper = null;
  }

  componentDidMount() {
    const { getWhyHostReview } = this.props;
    const isBrowser = typeof window !== "undefined";
    const reviewData = getWhyHostReview?.getHomeWhyHostReview?.results || [];

    // ✅ initial truncate length
    this.updateTruncateLength();

    // ✅ resize listener
    if (isBrowser) {
      window.addEventListener("resize", this.updateTruncateLength);
    }

    let smallDevice = isBrowser
      ? window.matchMedia("(max-width: 768px)").matches
      : true;

    let showArrow = false;
    if (smallDevice) {
      showArrow = reviewData.length > 1;
    } else {
      showArrow = reviewData.length > 3;
    }

    this.setState({
      showArrow,
      load: true,
    });
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateTruncateLength);
    }
  }

  // ✅ set truncate length by screen size
  updateTruncateLength = () => {
    if (typeof window === "undefined") return;

    const width = window.innerWidth;
    let truncateLength = 200; // desktop default

    if (width <= 768) {
      truncateLength = 100; // mobile
    } else if (width <= 1024) {
      truncateLength = 150; // tablet
    }

    this.setState({ truncateLength });
  };

  goNext = () => {
    if (this.swiper) this.swiper.slideNext();
  };

  goPrev = () => {
    if (this.swiper) this.swiper.slidePrev();
  };

  handleShow = (text, name, img) => {
    this.setState({
      showModal: true,
      modalText: text,
      modalName: name,
      modalImg: img,
    });
  };

  handleClose = () => {
    this.setState({
      showModal: false,
      modalText: "",
      modalName: "",
      modalImg: "",
    });
  };

  render() {
    const {
      getWhyHostReview: { getHomeWhyHostReview },
    } = this.props;
    const {
      showArrow,
      load,
      showModal,
      modalText,
      modalName,
      modalImg,
      truncateLength,
    } = this.state;

    let testimonials = [];
    if (
      getHomeWhyHostReview &&
      getHomeWhyHostReview.results &&
      getHomeWhyHostReview.results.length > 0
    ) {
      testimonials = getHomeWhyHostReview.results
        .filter(
          (review) => review.displayPage === 1 || review.displayPage === 3
        )
        .map((review) => ({
          id: review.id,
          img: review.image
            ? `${imageCdnUrl}home/${review.image}`
            : `${imageCdnUrl}staticImages/defaultPic.png`,
          text: review.reviewContent,
          name: review.userName,
        }));
    }

    if (!testimonials || testimonials.length === 0) {
      return null;
    }

    const params = {
      slidesPerView: 2,
      spaceBetween: 30,
      loop: testimonials.length > 1,
      breakpoints: {
        768: { slidesPerView: "auto" },
        767: { slidesPerView: 1 },
      },
    };

    return (
      <div className={s.container}>
        <h2 className={s.heading}>
          <FormattedMessage {...messages.dogTestimonialTitle} />
        </h2>

        <Row className={`${s.dFlex} ${s.alignItemsStart}`}>
          <Col xs={12} sm={4} md={3} lg={3}>
            <img
              src={`${imageCdnUrl}staticImages/dogTestimonials.png`}
              alt="Dog"
              className={s.dogImage}
            />
          </Col>
          <Col xs={12} sm={8} md={9} lg={9}>
            {load && testimonials.length > 0 && (
              <div>
                <Swiper
                  className={s.customDesign}
                  {...params}
                  ref={(node) =>
                    (this.swiper = node !== null ? node.swiper : null)
                  }
                >
                  {testimonials.map((item) => (
                    <div key={item.id} className={s.testimonialCard}>
                      <div className={s.testimonialText}>
                        <div className={s.flex}>
                          <div>
                            <img
                              src={item.img}
                              className={s.imgCss}
                              onError={(e) => {
                                e.currentTarget.src = `${imageCdnUrl}staticImages/defaultPic.png`;
                              }}
                            />
                          </div>

                          {item.text.length > truncateLength ? (
                            <div className={`${s.pl10} ${s.h95}`}>
                              {item.text.slice(0, truncateLength)}...{" "}
                              <span
                                className={s.readMore}
                                onClick={() =>
                                  this.handleShow(
                                    item.text,
                                    item.name,
                                    item.img
                                  )
                                }
                              >
                                <FormattedMessage {...messages.readmore} />
                              </span>
                            </div>
                          ) : (
                            <div className={`${s.pl10} ${s.h95}`}>
                              {item?.text || ""}
                            </div>
                          )}
                        </div>
                        <p className={s.cardName}>
                          <span></span>
                          {item?.name || ""}
                        </p>
                      </div>
                    </div>
                  ))}
                </Swiper>

                {testimonials.length > 1 && (
                  <div className={s.arrowCenter}>
                    <SamplePrevArrow
                      className={cx(s.displayInline, "hostArrowRTL")}
                      onClick={this.goPrev}
                    />
                    <SampleNextArrow
                      className={cx(s.displayInline, "hostArrowRTL")}
                      onClick={this.goNext}
                    />
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>

        {/* ✅ Modal for full text */}
        <Modal
          className="reviewModel"
          show={showModal}
          onHide={this.handleClose}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage {...messages.review} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={s.testimonialText}>
              <div className={s.flex}>
                <div>
                  {modalImg && (
                    <img
                      src={modalImg}
                      className={s.imgCss}
                      onError={(e) => {
                        e.currentTarget.src = `${imageCdnUrl}staticImages/defaultPic.png`;
                      }}
                    />
                  )}
                </div>

                <div className={s.pl10}>{modalText}</div>
              </div>
              <p className={s.cardName}>
                <span></span>
                {modalName}
              </p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getWhyHostPageSettings, {
    options: { fetchPolicy: "network-only", ssr: false },
  }),
  graphql(getWhyHostReview, {
    name: "getWhyHostReview",
    options: { fetchPolicy: "network-only", ssr: false },
  })
)(DogTestimonials);
